/**
 * * Модель обновления даты дедлайна
 */
export class TaskUpdateDateEndModel {
  /**ID задачи */
  Id!: number;
  /**Дата дедлайна */
  DateEnd!: Date;

  constructor(obj?: Partial<TaskUpdateDateEndModel>) {
    Object.assign(this, obj);
  }
}
